<template>
<div id="ScannedGallery">
  <!-- <pre>{{pet_data.settings_privacy.showGallery}}</pre>
  <pre>{{pet_gallery}}</pre> -->
  <div class="gallery-section" v-if="pet_data.settings_privacy.showGallery && pet_gallery.length > 0">
    <ScannedPetGallery :pet_gallery="pet_gallery" @enlargeImg="enlargeImg" />
    <EnlargeGalleryImage
    :pet_image="enlarge_image"
    @enlargeImg="enlargeImg"
    v-if="enlarge_image != ''"/>
  </div>

  <div class="no-gallery"  v-else-if="pet_gallery.length == 0">
    <div class="no-contact-box">
      <img src="@/assets/svg/pet-card-icon/gallery.svg" class="pic-upload" >
      <h3 class="headtext-gallery">Ohh No...!</h3>
      <p class="gallery-text">{{pet_data.name}} doesn't have any cute photos.</p>
    </div>
  </div>

  <div class="no-gallery" v-else>
    <div class="no-contact-box">
      <img src="@/assets/svg/login/lock.svg" class="pic-upload" >
      <p class="gallery-text">{{pet_data.name}}'s photos are hidden.</p>
    </div>
  </div>

</div>
</template>
<script>
// import {mapState} from 'vuex'
import axios from 'axios'
import ScannedPetGallery from '@/petprofile/components/scanned/ScannedPetGallery.vue'
import EnlargeGalleryImage from '@/petprofile/components/scanned/EnlargeGalleryImage.vue'

export default {
  name: 'ScannedGallery',
  components:{
    ScannedPetGallery,
    EnlargeGalleryImage
  },
  props: ['ownerdata', 'pet_data', 'userID'],
  data(){
    return{
      pet_gallery: [],
      enlarge_image: '',
      pet_id: this.$route.params.pet_id,
      processing: false
    }
  },
  methods: {
    
    enlargeImg(val){
      this.enlarge_image = val
    },
    async fetchPetGallery() {
      this.processing = true
      try {
        const res = await axios.get(`${this.$api_path}/pets/${this.pet_id}/gallery`);
        // Assuming the res contains an array of image URLs
        this.pet_gallery = res.data.result;
        this.processing = false
        console.log("res.data.", res.data.result)
        console.log("this.pet_gallery", this.pet_gallery)
      } catch (error) {
        this.processing = false
        console.error("Error fetching pet gallery:", error);
        // Handle error appropriately
      }
    }
  },
  computed:{
    randomGalleryText(){
      const cleaver_text = [
        'This pet doesn\'t have any cute photos.'
      ]
      let item = cleaver_text[Math.floor(Math.random() * cleaver_text.length)];
      return item
    },
    placeholderGallery:{
      get(){
        let base_count = 12
        base_count = base_count - this.pet_gallery.length
        return base_count
       },
       set(value)
       {
         let base_count = value
         return base_count
       }
    },
  },
  // computed:{
  //   ...mapState(['pet_data'])
  // },
  mounted(){
    this.fetchPetGallery()
  }
}
</script>
<style scoped>

#ScannedGallery{
  width: 100%;
  height: 100%;
  transition:1s;
  padding-bottom: 10rem;

}
.no-gallery{

  position: relative;
  border-radius: 10px;
  width: 90%;
  min-height: 15rem;
  margin: 1rem auto;
  margin-top: 1rem;
  display: flex;
  justify-content:center;
  align-items:center;
}
.no-contact-box{
  padding-top: 5rem;
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items:center;
  width: 100%;
  height: 15rem;
  backdrop-filter: blur( 17.0px );
  -webkit-backdrop-filter: blur( 17.0px );
  border-radius: 10px;
}
.no-contact-box img{
  width: 8rem;
  transition: 1s;
  margin: 1rem auto;
}
.headtext-gallery{
  margin-bottom: 1rem;
}
.pic-upload{
  position: relative;
  width: 7rem;
  height: 7rem;
  margin: 3rem auto;
  text-align:center;
  overflow:hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 70%;
}

.gallery-text{
  font-weight: bold;
  color: #adb6e1;
  text-align:center;
  font-size: 1rem;
}
.pic-upload:hover img{
  transform: translateY(-6px);
}
.cell{
  width:100%;
  height: 100%;
  min-width: 5rem;
  min-height: 5rem;
  margin: 0;
  border-radius: 10px;
  overflow:hidden;
  position: relative;
  /* Create the parallax scrolling effect */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content:center;
  align-items:center;
  text-align: center;
  transition: 1s;
}
.add-sign{
  min-width: 5rem;
  min-height: 5rem;
  margin: 0 auto;
  background-color: #f1f1f1;
}
.add-img-cell{
  background-color: #e5e5e5;
}
.grid-gall{
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr;
  grid-column-gap: .5px;
  grid-row-gap: 1px;
  justify-items: center;
  align-items: center;
  margin-bottom: -5rem;
  z-index: 0;
}
@media screen and (max-width: 600px) {
  .no-contact-box{
    height: 16rem;
  }
  .gallery-text{
    font-size: 1rem;
    margin-bottom: 1.1rem;
  }

}
</style>
